import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface KeyDistributionChartProps {
  data: {
    instanceKeys: number;
    taskKeys: number;
    sessionKeys: number;
    otherKeys: number;
  };
}

export function KeyDistributionChart({ data }: KeyDistributionChartProps) {
  const chartData = {
    labels: ['Instance Keys', 'Task Keys', 'Session Keys', 'Other Keys'],
    datasets: [
      {
        label: 'Key Distribution',
        data: [
          data.instanceKeys,
          data.taskKeys,
          data.sessionKeys,
          data.otherKeys
        ],
        backgroundColor: [
          'rgba(99, 102, 241, 0.8)',   // Indigo 500
          'rgba(168, 85, 247, 0.8)',   // Purple 500
          'rgba(59, 130, 246, 0.8)',   // Blue 500
          'rgba(75, 85, 99, 0.8)',     // Gray 600
        ],
        borderColor: [
          'rgba(99, 102, 241, 1)',
          'rgba(168, 85, 247, 1)',
          'rgba(59, 130, 246, 1)',
          'rgba(75, 85, 99, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          color: 'white',
          padding: 20,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: 'white',
        bodyColor: 'white',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
      }
    },
  };

  return (
    <div className="h-64 w-full">
      <Pie data={chartData} options={options} />
    </div>
  );
}